import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-[var(--color-primary)] via-[var(--color-brand-primary)] to-[var(--color-secondary)] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 md:mb-6">
            Start Your Cryptocurrency Journey Today
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-white/90 mb-8 md:mb-12 max-w-3xl mx-auto">
            Join over 500,000 investors who trust Kryptostash for secure, educational, and rewarding cryptocurrency investing
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-12">
            <Button 
              variant="default" 
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              className="bg-white text-[var(--color-primary)] hover:bg-white/90"
              onClick={() => window.location.href = '/registration'}
            >
              Create Free Account
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              className="border-white text-white hover:bg-white/10"
            >
              Talk to an Expert
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="#FFFFFF" />
              <span className="text-sm md:text-base">No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="#FFFFFF" />
              <span className="text-sm md:text-base">Start with as little as $10</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="#FFFFFF" />
              <span className="text-sm md:text-base">Cancel anytime</span>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                <Icon name="UserPlus" size={24} color="#FFFFFF" />
              </div>
              <h3 className="text-lg font-semibold text-white">1. Sign Up</h3>
            </div>
            <p className="text-sm text-white/80">
              Create your account in minutes with our streamlined KYC process
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                <Icon name="Wallet" size={24} color="#FFFFFF" />
              </div>
              <h3 className="text-lg font-semibold text-white">2. Fund Account</h3>
            </div>
            <p className="text-sm text-white/80">
              Add funds securely via ACH, wire transfer, or debit card
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                <Icon name="TrendingUp" size={24} color="#FFFFFF" />
              </div>
              <h3 className="text-lg font-semibold text-white">3. Start Trading</h3>
            </div>
            <p className="text-sm text-white/80">
              Buy, sell, and manage your cryptocurrency portfolio with ease
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;